export class DropDownValue {    
    constructor(
        public Id?, 
        public Description?,
        public LUDT?,
        public Type?,
        public UN?
        ) { }
}